// extracted by mini-css-extract-plugin
module.exports = {"root":"NoEventsBlock_root__0uVCo","root__icon":"NoEventsBlock_root__icon__g_Y0L","contents":"NoEventsBlock_contents__kmZO_","contents__text":"NoEventsBlock_contents__text__LzWCG"};